module.exports = __webpack_public_path__ + "img/icon_handshake.d45e0508.png";